import { Component, Element, Host, Prop, h } from '@stencil/core';
import { BlogPost } from '../../../types/blog';
import { getAssetsURL } from '../../../utils/utils';
import { Consumer } from '@sydle/ui-utils';

@Component({
  tag: 'sy-blog-author',
  styleUrl: './scss/index.scss',
  shadow: true,
})
export class SyBlogAuthor {
  private consumer: Consumer;
  @Element() el: HTMLSyBlogAuthorElement;

  /**
   * Post body
   */
  @Prop() postBody: BlogPost;

  /** Author's name */
  @Prop() name: string | undefined;

  /** URL to author's web page */
  @Prop() href: string | undefined;

  private author;

  connectedCallback() {
    this.consumer = new Consumer(this.el);
    this.consumer.subscribe('postBody', (post: BlogPost) => (this.postBody = post));
  }

  disconnectedCallback() {
    this.consumer.disconnect();
  }

  render() {
    this.author = this.postBody?.author;
    if (this.postBody && this.author) {
      this.name = this.author.name;
      this.href = this.author.url
        ? this.author.url.match(/https:\/\//)
          ? this.author.url
          : 'https://' + this.author.url
        : '';
    }
    if (!this.author) return null;

    return (
      <Host>
        <sy-avatar
          rounded
          slot="picture"
          image={this.author.photoId && getAssetsURL(this.author.photoURL)}
          initials={this.author.name.toUpperCase()[0]}
          initialsSize={1}
          objectFit="contain"
        />
        <div id="text-content">
          <sy-text type="h5" id="name">
            {this.href ? (
              <a href={this.href} target="_blank" rel="noreferrer">
                {this.name}
              </a>
            ) : (
              this.name
            )}
          </sy-text>
          <sy-text slot="description" innerHTML={this.author.description}></sy-text>
        </div>
      </Host>
    );
  }
}
